<template>
    <div :style="getStyle()" class="border-container">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        padding: {
            type: Array,
            default: () => []
        }
    },
    name: "BorderContainer",
    methods: {
        getStyle() {
            const style = {}

            if (this.padding.length) {
                style.padding = this.padding.map(n => `${n}px`).join(" ")
            }

            return style
        }
    }
}
</script>

<style scoped lang="sass">
.border-container
    border-radius: 10px
    padding: 20px
    background: hsla(0, 0%, 100%, 1)
    border: 1px solid #E0E0EC
    transition: .2s
    &.container-hidden
        background: #FBFCFF
</style>
